import { Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ImageCroppedEvent, ImageTransform, base64ToFile } from 'ngx-image-cropper';
import { OnboardingService } from '../../onboarding.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-setup3',
  templateUrl: './setup3.component.html',
  styleUrls: ['./setup3.component.css']
})
export class Setup3Component implements OnInit {
  isChecked1: any;
  isChecked2: any;
  isChecked3: any;
  isChecked4: any;
  isChecked5: any;
  isChecked6: any;
  isChecked7: any;
  isChecked8: any;
  isChecked9: any;
  isChecked10: any
  textField: any;
  imgChangeEvt: any = '';
  cropImgPreview: any = '';
  userId: any;
  text: any;
  croppedImage: any;
  stopCropper: boolean = true;
  imageBoxDisable: boolean = true;
  imageFlag: boolean = false;
  iconDisabled: boolean = true;
  cropButton: boolean = false;
  imageText: any;
  // originalFile: any;
  files: File;
  imgFile: File;
  finalImage: any;
  originalFile: any;
  cropImgButton: boolean = true;
  clickedCrop: boolean = false;
  canvasRotation = 0;
  rotation = 0;
  scale = 1;
  transform: ImageTransform = {};
  containWithinAspectRatio: boolean;
  textField2: any;
  angle = 0;
  finalObject: any = {}
  textField3: any;
  textField4: any;
  public myForm: FormGroup;
  submitEnabled:boolean;
  textFieldTitle: any;
  urlRegEx = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/ ;
  userProfile: any;
  treasuryData: any;

  constructor(private OnboardingService: OnboardingService, private renderer: Renderer2, private formBuilder: FormBuilder,  private route: ActivatedRoute,

    private Router: Router) {{this.userId = route.snapshot.params.id; }
    this.myForm = formBuilder.group({
      title: ['', ([Validators.required])],
      category: ['', ([Validators.required])],
      description: ['',([Validators.required, Validators.minLength(6), Validators.maxLength(500)])],
      url: ['', [Validators.required,  Validators.pattern(this.urlRegEx)]]
    })
  }
  ngOnInit(): void {
    this.myForm = this.formBuilder.group({
      title: ['', ([Validators.required])],
      category: ['', ([Validators.required])],
      description: ['',([Validators.required, Validators.minLength(6), Validators.maxLength(500)])],
      url: ['', [Validators.required,  Validators.pattern(this.urlRegEx)]]

    });
  const data=  this.OnboardingService.getUserProfile(this.userId).subscribe((res) => {
      this.userProfile = res;
      this.treasuryData=this.userProfile.treasuries;
     console.log(this.treasuryData[0]?.treasuryTitle)
        // this.myForm.controls['image'].setValue(this.treasuryData[0]?.treasuryImageUrl);
        this.myForm.controls['title'].setValue(this.treasuryData[0]?.treasuryTitle); 
        this.myForm.controls['url'].setValue(this.treasuryData[0]?.treasuryExpThis);
        this.myForm.controls['description'].setValue(this.treasuryData[0]?.treasuryDesc);
        this.myForm.controls['category'].setValue(this.treasuryData[0]?.treasuryName);
    if(this.treasuryData[0]?.treasuryImageUrl){
      this.cropImgPreview=this.treasuryData[0]?.treasuryImageUrl;
      this.croppedImage=this.cropImgPreview;
      this.imageBoxDisable=false;
    
    }

return data
})

  }
  checkTextBoxvalue(event) {

  }
  checkCheckBoxvalue(event) {

    console.log(event)

  }



  onFileChange(event: any): void {
    // this.imgChangeEvt = event;
    // this.stopCropper = true;
    // this.imageFlag = true;
    // this.iconDisabled = false;
    // this.transform = this.cropImgPreview;
    this.imgChangeEvt = event;
    console.log(event)
    this.transform = this.cropImgPreview;
    this.stopCropper = true;
    this.imageFlag = true;
    this.iconDisabled = false;
    this.originalFile = event.target.files[0];
    console.log(this.originalFile)

    if (event.target.files[0].size >= 41943040) {
      console.log(event.target.files[0].size)

      alert("File size is too big")
      this.imageFlag = false;
      this.imgChangeEvt = '';
      this.iconDisabled = true;
      this.clickedCrop = true;
    }
    else {

    }

  }
  click() {
    this.stopCropper = true;
    this.cropButton = true;
  }
  imageCropped(event: ImageCroppedEvent, file: any) {


    // this.cropImgPreview = event.base64;
    // this.croppedImage = this.cropImgPreview;
    // this.cropImageData(this.croppedImage)
    this.cropImgPreview = event.base64;
    this.croppedImage = this.cropImgPreview;
    console.log(this.croppedImage)
    const file1 = new File([base64ToFile(this.croppedImage)],
      this.originalFile.name, {
      lastModified: this.originalFile.lastModified,
      type: this.originalFile.type

    });
    console.log(file1)


  }

  imgLoad() {
    // display cropper tool
  }
  initCropper() {
    // init cropper
  }

  imgFailed() {
    // error msg
  }
  cropImage(file: any) {
    this.cropImgButton = false;
    this.stopCropper = false;
    this.imageBoxDisable = false
    this.clickedCrop = true;
    this.croppedImage=  base64ToFile(this.croppedImage);
    this.finalImage= URL.createObjectURL(this.croppedImage);
    let mysrc;
    const reader = new FileReader();
    reader.readAsDataURL(this.croppedImage); 
    reader.onloadend = function() {
       mysrc = reader.result;     
    }
    mysrc=this.croppedImage

     console.log(this.croppedImage)
  }


  get m() {
    return this.myForm.controls;
  }
skip(){
  this.Router.navigate(['/userProfiles/'+this.userId+'/setup/4'],{ queryParams: {iAmVideo : true} } );
}

  submit() {
    let createrOf: any = [{
      Checked: this.isChecked1,
      value: ' Art & Design'
    },
    {
      Checked: this.isChecked2,
      value: '  Books & Storytelling'
    },
    {
      Checked: this.isChecked3,
      value: 'Dance'
    },
    {
      Checked: this.isChecked4,
      value: 'Fashion'
    },
    {
      Checked: this.isChecked5,
      value: ' Film'
    },
    {
      Checked: this.isChecked6,
      value: ' Music'
    },
    {
      Checked: this.isChecked7,
      value: 'Tech & Science'
    },
    {
      Checked: this.isChecked8,
      value: 'Television'
    },
    {
      Checked: this.isChecked9,
      value: 'Virtual Reality'
    },
    {
      Checked: this.isChecked10,
      value: this.textField
    }];
    let finalObject: any = {
      treasuryName: this.myForm.get('category').value + '',
      treasuryTitle:this.myForm.get('title').value,
      treasuryDesc: this.myForm.get('description').value,
      expThisLink: this.myForm.get('url').value,
      imageRotationDegrees: ''
    }

    for (let i = 0; i < createrOf.length; i++) {

      if (createrOf[i].Checked) {
        finalObject.treasuryName = (createrOf[i].value);
      }
    }
    
    if(!this.treasuryData[0]?.treasuryImageUrl && finalObject){
      const data = this.OnboardingService.postSetup3(this.croppedImage,this.userId,finalObject).subscribe();
  console.log(data)
  this.Router.navigate([`/userProfiles/${this.userId}/setup/4`],{ queryParams: { iAmVideo : true} });

     }
    else if(this.treasuryData[0]?.treasuryImageUrl){
      this.Router.navigate([`/userProfiles/${this.userId}/setup/4`],{ queryParams: { iAmVideo : true} });
    }
  }
}